import { API_BASE_URL } from "src/constants";
import { post } from "src/core/utils/api";
import { LensesDataItem, LensesDetailDataItem } from "src/types/costExplosion";

const createLensesService = () => {
  const fetchLensesDataItems = async (
    accessToken: string,
    modelNumber: string,
    skus: string[],
    includeManualAdjustment?: boolean
  ): Promise<LensesDataItem[]> => {
    return await post<LensesDataItem[]>(
      accessToken,
      API_BASE_URL +
        `/v1/ce/lens/data/recap?modelNumber=${modelNumber}&includeManualAdjustment=${includeManualAdjustment}`,
      { values: skus }
    );
  };

  const fetchLensesDetailDataItems = async (
    accessToken: string,
    modelNumber: string,
    skus: string[],
    includeManualAdjustment?: boolean
  ): Promise<LensesDetailDataItem[]> => {
    return await post<LensesDetailDataItem[]>(
      accessToken,
      API_BASE_URL +
        `/v1/ce/lens/data/details?modelNumber=${modelNumber}&includeManualAdjustment=${includeManualAdjustment}`,
      { values: skus }
    );
  };

  return { fetchLensesDataItems, fetchLensesDetailDataItems };
};

export const lensesService = createLensesService();
